export function getAvailableDevices(devices = []) {
    let list = [];
    let properDeviceName = '';

    let properOsNames = {
        'android': 'Android',
        'windows': 'Windows',
        'ubuntu': 'Ubuntu',
        'ios': 'iOS'
    };

    let properTypeNames = {
        'tablet': 'Tablet',
        'mobile': 'Smartphone',
        'desktop': 'Desktop'
    };

    devices.forEach((device) => {
        switch (device.type) {
            case 'tablet':
            case 'mobile': {
                properDeviceName = 'Mobile' + '-' + properTypeNames[device.type] + (device.os
                    ? '-' + (properOsNames[device.os] || device.os) : '');
                break;
            }
            case 'desktop': {
                properDeviceName = 'Desktop' + (device.os ? '-' + properOsNames[device.os] : '');
                break;
            }
            default: {
                properDeviceName = device.os ? device.os : '';
            }

        }
        list.push(properDeviceName);
        properDeviceName = '';
    });

    return list.join(', ');
};
